import hexRgb from 'hex-rgb';
import memoizeOne from 'memoize-one';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

var STMapMarkerType;

(function (STMapMarkerType) {
  /** 场景标记 */
  STMapMarkerType[STMapMarkerType["scene"] = 0] = "scene";
  /** 点标记 */

  STMapMarkerType[STMapMarkerType["point"] = 1] = "point";
  /** 文本标记 */

  STMapMarkerType[STMapMarkerType["text"] = 2] = "text";
  /** 贴图标记 */

  STMapMarkerType[STMapMarkerType["image"] = 3] = "image";
  /** 折线标记 */

  STMapMarkerType[STMapMarkerType["polyline"] = 4] = "polyline";
  /** 圆形标记 */

  STMapMarkerType[STMapMarkerType["circle"] = 5] = "circle";
  /** 多边形标记 */

  STMapMarkerType[STMapMarkerType["polygon"] = 6] = "polygon";
  /** 脉冲标记 */

  STMapMarkerType[STMapMarkerType["pulse"] = 7] = "pulse";
})(STMapMarkerType || (STMapMarkerType = {}));

var SceneType;

(function (SceneType) {
  SceneType[SceneType["panoVideo"] = 0] = "panoVideo";
  SceneType[SceneType["pano"] = 1] = "pano";
  SceneType[SceneType["matrix"] = 2] = "matrix";
  SceneType[SceneType["image"] = 3] = "image";
  SceneType[SceneType["video"] = 4] = "video";
  SceneType[SceneType["tour"] = 5] = "tour";
})(SceneType || (SceneType = {}));

var MediaType;

(function (MediaType) {
  MediaType[MediaType["system"] = 0] = "system";
  MediaType[MediaType["lib"] = 1] = "lib";
})(MediaType || (MediaType = {}));

var FeatureType;

(function (FeatureType) {
  FeatureType[FeatureType["link"] = 0] = "link";
  FeatureType[FeatureType["mobile"] = 1] = "mobile";
  FeatureType[FeatureType["map"] = 2] = "map";
  FeatureType[FeatureType["media"] = 3] = "media";
  FeatureType[FeatureType["text"] = 4] = "text";
  FeatureType[FeatureType["article"] = 5] = "article";
  FeatureType[FeatureType["audio"] = 6] = "audio";
  FeatureType[FeatureType["video"] = 7] = "video";
  FeatureType[FeatureType["seqFrame"] = 8] = "seqFrame";
  FeatureType[FeatureType["scene"] = 9] = "scene";
  FeatureType[FeatureType["noFunc"] = 10] = "noFunc";
  FeatureType[FeatureType["event"] = 11] = "event";
  FeatureType[FeatureType["miniProgram"] = 12] = "miniProgram";
  FeatureType[FeatureType["doc"] = 13] = "doc";
  FeatureType[FeatureType["model3d"] = 14] = "model3d";
  FeatureType[FeatureType["prevScene"] = 15] = "prevScene";
  FeatureType[FeatureType["nextScene"] = 16] = "nextScene";
})(FeatureType || (FeatureType = {}));

var CFMediaLayoutStyle;

(function (CFMediaLayoutStyle) {
  CFMediaLayoutStyle[CFMediaLayoutStyle["list"] = 0] = "list";
  CFMediaLayoutStyle[CFMediaLayoutStyle["waterfall"] = 1] = "waterfall";
  CFMediaLayoutStyle[CFMediaLayoutStyle["bigPic"] = 2] = "bigPic";
  CFMediaLayoutStyle[CFMediaLayoutStyle["splitScreen"] = 3] = "splitScreen";
})(CFMediaLayoutStyle || (CFMediaLayoutStyle = {}));

var CFViewerPlayType;

(function (CFViewerPlayType) {
  CFViewerPlayType[CFViewerPlayType["cick"] = 0] = "cick";
  CFViewerPlayType[CFViewerPlayType["auto"] = 1] = "auto";
  CFViewerPlayType[CFViewerPlayType["loop"] = 2] = "loop";
})(CFViewerPlayType || (CFViewerPlayType = {}));

var LinkTarget;

(function (LinkTarget) {
  LinkTarget[LinkTarget["modal"] = 0] = "modal";
  LinkTarget[LinkTarget["blank"] = 1] = "blank";
  LinkTarget[LinkTarget["window"] = 2] = "window";
})(LinkTarget || (LinkTarget = {}));

function colorObjToString(color) {
  var r = color.r,
      g = color.g,
      b = color.b,
      _color$a = color.a,
      a = _color$a === void 0 ? 1 : _color$a;
  return r + "," + g + "," + b + "," + a;
}
function hexToColorString(_ref) {
  var hex = _ref.hex,
      _ref$alpha = _ref.alpha,
      alpha = _ref$alpha === void 0 ? 1 : _ref$alpha;

  var _hexRgb = hexRgb(hex),
      r = _hexRgb.red,
      g = _hexRgb.green,
      b = _hexRgb.blue;

  return colorObjToString({
    r: r,
    g: g,
    b: b,
    a: alpha
  });
}
var getImageSize = /*#__PURE__*/memoizeOne(function (src) {
  return new Promise(function (resolve, reject) {
    var image = new Image();

    image.onload = function () {
      return resolve({
        width: image.naturalWidth,
        height: image.naturalHeight
      });
    };

    image.onerror = function () {
      reject('图片宽高读取错误，请重试');
    };

    image.src = "" + src;
  });
});

var MARKER_SIZE = 24;
var MARKER_IMAGE_SIZE = 30;
var BASE_ZINDEX = 100;
var SELELCTED_ZINDEX = 999;
var IMG_RADAR = 'data:image/png;base64,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';
var IMG_ANCHOR = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAES0lEQVR4Ae3gAZAkSZIkSRKLqpm7R0REZmZmVlVVVVV3d3d3d/fMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMdHd3d3dXV1VVVVVmZkZGRIS7m5kKz0xmV3d1d3dPz8zMzMxMYuXfRjwn869D4V9PQAAVKPzbUPjXERDAAjgObAAJNP51qPzrFeCY7TsAJN0EDEDyoiP41xFQgAXPtgAKIF50VP5tCs9W+Nej8t+D4EUnrihA4dkKULhCvGiovGgEBDADtoEdnm0b2AYSWAMJmBeO4F8moAJbwHW/8zu/84H33HPPt/JM995777f+xV/8xccC1wFbQAXEC0fhhRMQwOZnfuZnvuzP//zP//AjHvGIt9va2rqWZ9rc3Lz2+uuvf9WP+qiPeo3ZbPZ3v/M7v3MOGHnhEM8mrhDPaQ5cd+HChR87ceLEyy6Xy3t+6Zd+6au+8Ru/8Y8APvRDP/RV3uRN3uRjFovFdQcHB0/a3t5+E+AeYMVzMlcYoHCFgAAq0AEVqMAM2PmLv/iLj3zoQx/6dsvl8p5P/dRPfd+P/diP/dWnP/3pdzz96U+/90d/9Ecff3h4+Cev9Vqv9Xqbm5sPet3Xfd2L3/3d3/0PgIEAKlAB8WwIEBDABrADbADBFQXYuffee7/lmmuuecmf/Mmf/KS3e7u3+z7gAjBxRQVO/sRP/MR7vO3bvu2X3HvvvX933XXXfSCwBzSuSOAI2AOOgBQgoANO2b6LF+L1X//1X/M3fuM3/hY4ABpXFGDr9V7v9V7y13/913+XF0LSDcB5YKz89yC4ogEHkm6S9EhJj5b0aEkvJulV7r333r8D+NAP/dBXATaAChSgABXY+NAP/dBXAbjvvvv+VtKrSHoxSY+W9GhJj5R0E3AANIAADCRwBJwF7gBuA24DbgOe8cQnPvEnAN7kTd7kYz76oz/6pYGTwBawBZz86I/+6Jd+kzd5k48BuOOOO34VeAZwG3AbcBtwB3AWOAISsHg2cYV4TnPguv39/V/a2tp65HK5vOeXfumXvuobv/Eb/wjgQz/0Q1/lTd7kTT5msVhcd/Hixb88efLkOwD3ACuek7nCAOKFExDA1md+5me+7Ed/9Ed/+YkTJ16W5+Pg4OBJX/ZlX/bBn/u5n/uXwAGQgHn+EP8yARXYAE79xV/8xYfcdNNNb3jNNde8JMC99977d0984hN/4rVe67W+DzgPHAETYF4wxItGQAAz4Bhwi+0/BpD0KsAzgEvAGkjAvHBUXjQGElgBAezzbHvAPrACDJh/GcGLzlzRgMazNaBxhXnRUPnvQeXfpvFsjX89Kv86Bhqw5NmWQAPMiw7xryMggAWwzRX7wBJIwLxoEP96AgIoXNGABMyLDvFvI56T+dfhHwFimROYMnwzJAAAAABJRU5ErkJggg==';
var AMapSandTable = /*#__PURE__*/function () {
  function AMapSandTable() {
    var _this = this;

    this.markerObjectMap = new Map();
    this.zoomWatchingMap = new Map();
    this.animationMarkerMap = new Map();
    this.layerMap = new Map();
    this.zIndexMap = new Map();
    this.zIndex = BASE_ZINDEX;

    this.onMarkerClick = function () {};

    this.onRadarRotate = function () {};

    this.isRotating = false;
    this.layers = [];
    this.publicDomain = '';
    this.mediaDomain = '';
    this.radarSize = 114;

    this.getZIndex = function (id) {
      var zIndex = _this.zIndexMap.get(id);

      if (zIndex !== undefined) {
        return zIndex;
      }

      _this.zIndex += 1;

      _this.zIndexMap.set(id, _this.zIndex);

      return _this.zIndex;
    };

    this.getExtData = function (object) {
      return object.getExtData();
    };

    this.getUrlByMediaType = function (mediaType, src) {
      if (!src) return '';
      return "" + (mediaType === 0 ? _this.publicDomain : _this.mediaDomain) + src;
    };

    this.onMouseMove = function (e) {
      var _this$radar, _this$map, _this$radar2;

      if (!e.pixel) return;
      var pos = (_this$radar = _this.radar) == null ? void 0 : _this$radar.getPosition();
      if (!pos) return;
      var pixel = (_this$map = _this.map) == null ? void 0 : _this$map.lngLatToContainer(pos);
      if (!pixel) return;
      var angle = Math.atan2(e.pixel.x - pixel.x, pixel.y - e.pixel.y) * (180 / Math.PI);
      (_this$radar2 = _this.radar) == null ? void 0 : _this$radar2.setAngle(angle);
      _this.onRadarRotate == null ? void 0 : _this.onRadarRotate(angle);
    };

    this.onMouseUp = function () {
      var _this$map2;

      document.removeEventListener('mouseup', _this.onMouseUp); // @ts-ignore

      document.removeEventListener('mousemove', _this.onMouseMove);
      document.removeEventListener('touchend', _this.onMouseUp); // @ts-ignore

      document.removeEventListener('touchmove', _this.onMouseMove);
      (_this$map2 = _this.map) == null ? void 0 : _this$map2.setStatus({
        dragEnable: true
      });
      _this.isRotating = false;
    };

    this.generateRadarIcon = function (scale) {
      if (scale === void 0) {
        scale = 1;
      }

      var width = _this.radarSize * scale;
      var height = _this.radarSize * scale;
      return "<img style=\"width:" + width + "px;height:" + height + "px;\" src=\"" + IMG_RADAR + "\" draggable=\"false\" />";
    };

    this.getMap = function () {
      if (!_this.map) throw new Error('地图未加载完成');
      return _this.map;
    };
    /**
     * 生成 Marker 图标的 HTML 字符串
     */


    this.markerIcon = function (data, opt) {
      if (opt === void 0) {
        opt = {};
      }

      var _data$type = data.type,
          type = _data$type === void 0 ? 0 : _data$type,
          scaleX = data.scaleX,
          scaleY = data.scaleY,
          borderColor = data.borderColor,
          fillColor = data.fillColor,
          activeBorderColor = data.activeBorderColor,
          activeFillColor = data.activeFillColor,
          mediaIcon = data.mediaIcon;

      if (type === 1 && mediaIcon) {
        var _width = MARKER_IMAGE_SIZE * scaleX;

        var _height = MARKER_IMAGE_SIZE * scaleY;

        var url = _this.getUrlByMediaType(mediaIcon.type, mediaIcon.url);

        var _markerString = "<img style=\"width:" + _width + "px;height:" + _height + "px;\" src=\"" + url + "\" draggable=\"false\" />";

        if (opt.isSelected) {
          var posMap = {
            'top-left': 'top:-6px;left:-6px',
            'top-center': 'top:-6px',
            'top-right': 'top:-6px;right:-6px',
            'middle-left': 'left:-6px',
            center: '',
            'middle-right': 'right:-6px',
            'bottom-left': 'bottom:-6px;left:-6px',
            'bottom-center': 'bottom:-6px',
            'bottom-right': 'bottom:-6px;right:-6px'
          };
          var pos = posMap[mediaIcon.anchor];
          var anchorString = "<img style=\"position:absolute;width:12px;height:12px;" + pos + "\" src=\"" + IMG_ANCHOR + "\" draggable={false} />";
          return "<div style=\"display:flex;justify-content:center;align-items:center;position:relative;outline:2px #F36264 solid;\">" + _markerString + anchorString + "</div>";
        }

        return _markerString;
      }

      var width = (_this.markerSize || MARKER_SIZE) * scaleX;
      var height = (_this.markerSize || MARKER_SIZE) * scaleY;
      var bgc = opt.isActive ? activeFillColor : fillColor;
      var bc = opt.isActive ? activeBorderColor : borderColor;
      var markerString = "<div style=\"width:" + width + "px;height:" + height + "px;background-color:rgba(" + bgc + ");border:2px solid rgba(" + bc + ");border-radius:9999px;\"/>";

      if (opt.isSelected) {
        return "<div style=\"border:2px #F36264 solid;padding:8px;border-radius:3px;background-color:rgba(0,0,0,.1);\">" + markerString + "</div>";
      }

      return markerString;
    };
    /**
     * 生成 Marker 的 Label 字符串
     */


    this.markerLabel = function (data, opt) {
      if (opt === void 0) {
        opt = {};
      }

      var _data$titleSetting = data.titleSetting,
          edge = _data$titleSetting.edge,
          ox = _data$titleSetting.ox,
          oy = _data$titleSetting.oy,
          align = _data$titleSetting.align,
          font = _data$titleSetting.font,
          background = _data$titleSetting.background,
          writingMode = _data$titleSetting.writingMode;
      var _background$bgColor = background.bgColor,
          bgColor = _background$bgColor === void 0 ? '0,0,0,0.5' : _background$bgColor,
          _background$borderWid = background.borderWidth,
          borderWidth = _background$borderWid === void 0 ? 0 : _background$borderWid,
          _background$borderCol = background.borderColor,
          borderColor = _background$borderCol === void 0 ? '0,0,0,0.5' : _background$borderCol,
          _background$bgRounded = background.bgRoundedge,
          bgRoundedge = _background$bgRounded === void 0 ? 5 : _background$bgRounded,
          _background$type = background.type,
          bgType = _background$type === void 0 ? 0 : _background$type,
          _background$gradientA = background.gradientAngle,
          gradientAngle = _background$gradientA === void 0 ? 0 : _background$gradientA,
          _background$gradientS = background.gradientStartColor,
          gradientStartColor = _background$gradientS === void 0 ? '0,0,0,0.5' : _background$gradientS,
          _background$gradientE = background.gradientEndColor,
          gradientEndColor = _background$gradientE === void 0 ? '0,0,0,0.5' : _background$gradientE;
      var fontColor = font.fontColor,
          fontSize = font.fontSize;
      var title = data.title;

      if (opt.isSelected && !title) {
        title = '请输入标记标题';
      }

      var content = '';

      if (data.showTitle && !!title && !_this.hideTitle) {
        var isVertical = writingMode === 1;
        var bgStr = bgType === 1 ? "linear-gradient(" + gradientAngle + "deg, rgba(" + gradientStartColor + "), rgba(" + gradientEndColor + "))" : "rgba(" + bgColor + ")";
        var stylesArr = ['white-space:pre', "background:" + bgStr, "padding:" + (isVertical ? '10px 5px' : '5px 10px'), "border-radius:" + bgRoundedge + "px", "ling-height:" + (isVertical ? 1.6 : 1.4), "font-size:" + fontSize + "px", "color:rgba(" + fontColor + ")", "text-align:" + align, "border:" + borderWidth + "px solid rgba(" + borderColor + ")", 'user-select: none'];

        if (isVertical) {
          stylesArr.push('letter-spacing:4px');
          stylesArr.push('writing-mode:vertical-lr');
        }

        content = "<div style=\"" + stylesArr.join(';') + "\">" + title + "</div>";
      }

      return {
        content: content,
        direction: edge,
        offset: [ox, oy]
      };
    };
    /**
     * 生成 Text 的样式
     */


    this.textStyle = function (data, opt) {
      if (opt === void 0) {
        opt = {};
      }

      var icon = data.icon,
          titleSetting = data.titleSetting;
      var zoom = icon.zoom,
          stick = icon.stick;
      var align = titleSetting.align,
          font = titleSetting.font,
          background = titleSetting.background,
          writingMode = titleSetting.writingMode;
      var _opt = opt,
          isSelected = _opt.isSelected;
      var _background$bgColor2 = background.bgColor,
          bgColor = _background$bgColor2 === void 0 ? '0,0,0,0.5' : _background$bgColor2,
          _background$borderWid2 = background.borderWidth,
          borderWidth = _background$borderWid2 === void 0 ? 0 : _background$borderWid2,
          _background$borderCol2 = background.borderColor,
          borderColor = _background$borderCol2 === void 0 ? '0,0,0,0.5' : _background$borderCol2,
          _background$bgRounded2 = background.bgRoundedge,
          bgRoundedge = _background$bgRounded2 === void 0 ? 5 : _background$bgRounded2,
          _background$type2 = background.type,
          bgType = _background$type2 === void 0 ? 0 : _background$type2,
          _background$gradientA2 = background.gradientAngle,
          gradientAngle = _background$gradientA2 === void 0 ? 0 : _background$gradientA2,
          _background$gradientS2 = background.gradientStartColor,
          gradientStartColor = _background$gradientS2 === void 0 ? '0,0,0,0.5' : _background$gradientS2,
          _background$gradientE2 = background.gradientEndColor,
          gradientEndColor = _background$gradientE2 === void 0 ? '0,0,0,0.5' : _background$gradientE2;
      var fontColor = font.fontColor,
          fontSize = font.fontSize;
      var isVertical = writingMode === 1;
      var bgStr = bgType === 1 ? "linear-gradient(" + gradientAngle + "deg, rgba(" + gradientStartColor + "), rgba(" + gradientEndColor + "))" : "rgba(" + bgColor + ")";
      var styles = {
        whiteSpace: 'pre',
        background: bgStr,
        padding: isVertical ? '10px 5px' : '5px 10px',
        borderRadius: bgRoundedge + "px",
        lineHeight: isVertical ? 1.6 : 1.4,
        fontSize: fontSize + "px",
        color: "rgba(" + fontColor + ")",
        textAlign: align,
        border: borderWidth + "px solid rgba(" + borderColor + ")",
        userSelect: 'none'
      };

      if (isVertical) {
        styles.letterSpacing = '4px';
        styles.writingMode = 'vertical-lr';
      }

      if (isSelected) {
        styles.outline = '2px #F36264 solid';
      }

      if (stick) {
        var _this$map$getZoom, _this$map3;

        var curZoom = (_this$map$getZoom = (_this$map3 = _this.map) == null ? void 0 : _this$map3.getZoom()) != null ? _this$map$getZoom : 13;

        var scale = _this.getZoomScale({
          zoom: curZoom,
          baseZoom: zoom
        });

        styles.transform = "scale(" + scale + ")";
      }

      return styles;
    };
    /** 贴图 */


    this.imageContent = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(icon // opt: { isSelected?: boolean } = {}
      ) {
        var _this$map$getZoom2, _this$map4;

        var scaleX, image, zoom, curZoom, zoomScale, scale, src, size, width, height;
        return runtime_1.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                scaleX = icon.scaleX, image = icon.image, zoom = icon.zoom;
                curZoom = (_this$map$getZoom2 = (_this$map4 = _this.map) == null ? void 0 : _this$map4.getZoom()) != null ? _this$map$getZoom2 : 13;
                zoomScale = _this.getZoomScale({
                  zoom: curZoom,
                  baseZoom: zoom
                });
                scale = scaleX * zoomScale;
                src = _this.getUrlByMediaType(image.type, image.url);
                _context.next = 7;
                return getImageSize(src);

              case 7:
                size = _context.sent;
                width = size.width * scale;
                height = size.height * scale;
                return _context.abrupt("return", new AMap.Icon({
                  size: new AMap.Size(width, height),
                  image: src,
                  imageSize: new AMap.Size(width, height)
                }));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    this.addMarker = function (markerData, opts) {
      if (opts === void 0) {
        opts = {};
      }

      // 如果已经存在则删除
      if (_this.markerObjectMap.get(markerData.id) || _this.layerMap.get(markerData.id)) {
        _this.removeMarker(markerData.id);
      }

      var zIndex = _this.getZIndex(markerData.id);

      switch (markerData.type) {
        case undefined:
        case STMapMarkerType.scene:
        case STMapMarkerType.point:
          {
            var _icon$mediaIcon$ancho, _icon$mediaIcon;

            var id = markerData.id,
                showTitle = markerData.showTitle,
                icon = markerData.icon;
            var cursor = markerData.type === STMapMarkerType.point && markerData.data.code === FeatureType.noFunc ? 'default' : 'pointer';
            var marker = new AMap.Marker(_extends({
              position: [icon.lng, icon.lat],
              draggable: false,
              cursor: cursor,
              anchor: icon.type === 1 ? (_icon$mediaIcon$ancho = (_icon$mediaIcon = icon.mediaIcon) == null ? void 0 : _icon$mediaIcon.anchor) != null ? _icon$mediaIcon$ancho : 'bottom-center' : 'center',
              zIndex: zIndex,
              content: _this.markerIcon(icon)
            }, !!showTitle && {
              label: _this.markerLabel(markerData)
            }, {
              extData: {
                markerData: markerData
              }
            }));
            var lastClickTime = 0;
            marker.on('click', function () {
              var currentTime = new Date().getTime();

              if (currentTime - lastClickTime > 300) {
                lastClickTime = currentTime;
                _this.onMarkerClick == null ? void 0 : _this.onMarkerClick(id, marker);
              }
            });
            marker.on('mouseup', _this.onMouseUp);

            _this.markerObjectMap.set(id, marker);

            if (!opts.hide) {
              marker.setMap(_this.map);
            }

            break;
          }

        case STMapMarkerType.text:
          {
            var _id = markerData.id,
                _icon = markerData.icon,
                title = markerData.title,
                data = markerData.data;

            var _marker = new AMap.Text({
              position: [_icon.lng, _icon.lat],
              cursor: data.code === FeatureType.noFunc ? 'default' : 'pointer',
              draggable: false,
              anchor: 'center',
              text: title || '请输入标记标题',
              zIndex: zIndex,
              visible: false,
              extData: {
                markerData: markerData
              },
              style: _this.textStyle(markerData)
            });

            _marker.on('click', function () {
              _this.onMarkerClick == null ? void 0 : _this.onMarkerClick(_id, _marker);
            });

            _this.markerObjectMap.set(_id, _marker);

            _this.zoomWatchingMap.set(_id, _marker);

            _marker.setMap(_this.map);

            _marker.show();

            break;
          }

        case STMapMarkerType.image:
          {
            var _id2 = markerData.id,
                _icon2 = markerData.icon,
                _data = markerData.data;

            var _marker2 = new AMap.Marker({
              position: [_icon2.lng, _icon2.lat],
              cursor: _data.code === FeatureType.noFunc ? 'default' : 'pointer',
              draggable: false,
              anchor: 'center',
              zIndex: zIndex,
              extData: {
                markerData: markerData
              },
              visible: false
            });

            _marker2.on('click', function () {
              _this.onMarkerClick == null ? void 0 : _this.onMarkerClick(_id2, _marker2);
            });

            _this.markerObjectMap.set(_id2, _marker2);

            _this.zoomWatchingMap.set(_id2, _marker2);

            _this.imageContent(_icon2).then(function (iconObj) {
              _marker2.setIcon(iconObj);

              _marker2.show();

              if (!opts.hide) {
                _marker2.setMap(_this.map);
              }
            });

            break;
          }

        case STMapMarkerType.polyline:
          {
            var _id3 = markerData.id,
                _icon3 = markerData.icon,
                _data2 = markerData.data;
            var path = _icon3.path,
                strokeStyle = _icon3.strokeStyle,
                borderStyle = _icon3.borderStyle,
                animation = _icon3.animation;
            if (!path.length) return;
            var polyline = new AMap.Polyline({
              path: path,
              cursor: _data2.code === FeatureType.noFunc ? 'default' : 'pointer',
              isOutline: true,
              outlineColor: borderStyle.color,
              borderWeight: borderStyle.width,
              strokeColor: strokeStyle.color,
              strokeOpacity: strokeStyle.opacity,
              strokeWeight: strokeStyle.width,
              strokeStyle: strokeStyle.type,
              zIndex: zIndex,
              extData: {
                markerData: markerData
              }
            });
            polyline.on('click', function () {
              _this.onMarkerClick == null ? void 0 : _this.onMarkerClick(_id3, polyline);
            });
            polyline.setMap(_this.getMap());

            _this.markerObjectMap.set(_id3, polyline);

            if (animation.type === 1) {
              var markerIcon = animation.markerIcon,
                  markerWidth = animation.markerWidth,
                  markerHeight = animation.markerHeight,
                  _animation$markerScal = animation.markerScale,
                  markerScale = _animation$markerScal === void 0 ? 1 : _animation$markerScal;
              var width = markerWidth * markerScale;
              var height = markerHeight * markerScale;
              var animationMarker = new AMap.Marker({
                map: _this.getMap(),
                position: path[0],
                icon: new AMap.Icon({
                  size: new AMap.Size(width, height),
                  image: "" + _this.publicDomain + markerIcon,
                  imageSize: new AMap.Size(width, height)
                }),
                anchor: 'center'
              });
              animationMarker.moveAlong(path, {
                duration: 500,
                autoRotation: true,
                circlable: true
              });

              _this.animationMarkerMap.set(_id3, animationMarker);
            }

            break;
          }

        case STMapMarkerType.pulse:
          {
            var _id4 = markerData.id,
                _icon4 = markerData.icon;
            var _path = _icon4.path,
                pulseStyle = _icon4.pulseStyle,
                _animation = _icon4.animation;
            if (!_path.length) return;
            var layer = new Loca.PulseLineLayer({
              zIndex: zIndex,
              opacity: 1,
              visible: true
            });
            var source = new Loca.GeoJSONSource({
              data: {
                type: 'FeatureCollection',
                features: [{
                  type: 'Feature',
                  properties: {},
                  geometry: {
                    type: 'LineString',
                    coordinates: _path
                  }
                }]
              }
            });
            layer.setStyle({
              altitude: 0,
              lineWidth: pulseStyle.width,
              headColor: "rgba(" + hexToColorString({
                hex: pulseStyle.headColor,
                alpha: pulseStyle.headOpacity
              }) + ")",
              trailColor: "rgba(" + hexToColorString({
                hex: pulseStyle.tailColor,
                alpha: pulseStyle.tailOpacity
              }) + ")",
              interval: 0.25,
              duration: 5000
            });
            layer.setSource(source);

            _this.loca.add(layer);

            _this.layerMap.set(_id4, {
              layer: layer,
              data: markerData
            });

            if (_animation.type === 1) {
              var _markerIcon = _animation.markerIcon,
                  _markerWidth = _animation.markerWidth,
                  _markerHeight = _animation.markerHeight,
                  _animation$markerScal2 = _animation.markerScale,
                  _markerScale = _animation$markerScal2 === void 0 ? 1 : _animation$markerScal2;

              var _width2 = _markerWidth * _markerScale;

              var _height2 = _markerHeight * _markerScale;

              var _animationMarker = new AMap.Marker({
                map: _this.getMap(),
                position: _path[0],
                icon: new AMap.Icon({
                  size: new AMap.Size(_width2, _height2),
                  image: "" + _this.publicDomain + _markerIcon,
                  imageSize: new AMap.Size(_width2, _height2)
                }),
                anchor: 'center'
              });

              _animationMarker.moveAlong(_path, {
                duration: 500,
                autoRotation: true,
                circlable: true
              });

              _this.animationMarkerMap.set(_id4, _animationMarker);
            }

            break;
          }

        case STMapMarkerType.circle:
          {
            var _id5 = markerData.id,
                _icon5 = markerData.icon,
                _data3 = markerData.data;
            var radius = _icon5.radius,
                lat = _icon5.lat,
                lng = _icon5.lng,
                fillStyle = _icon5.fillStyle,
                _borderStyle = _icon5.borderStyle,
                borderStyleActive = _icon5.borderStyleActive,
                fillStyleActive = _icon5.fillStyleActive,
                blink = _icon5.blink;
            if (!radius) return;
            var circle = new AMap.Circle({
              center: [lng, lat],
              cursor: _data3.code === FeatureType.noFunc ? 'default' : 'pointer',
              radius: radius,
              fillColor: fillStyle.color,
              fillOpacity: fillStyle.opacity,
              strokeColor: _borderStyle.color,
              strokeWeight: _borderStyle.width,
              strokeOpacity: _borderStyle.opacity,
              zIndex: zIndex,
              extData: {
                markerData: markerData
              }
            });
            circle.on('click', function () {
              _this.onMarkerClick == null ? void 0 : _this.onMarkerClick(_id5, circle);
            });
            var isMouseover = false;

            var toggleActive = function toggleActive(isActive) {
              var isOn = isMouseover || isActive;
              circle.setOptions({
                fillColor: isOn ? fillStyleActive.color : fillStyle.color,
                fillOpacity: isOn ? fillStyleActive.opacity : fillStyle.opacity,
                strokeColor: isOn ? borderStyleActive.color : _borderStyle.color,
                strokeWeight: isOn ? borderStyleActive.width : _borderStyle.width,
                strokeOpacity: isOn ? borderStyleActive.opacity : _borderStyle.opacity
              });
            };

            circle.on('mouseover', function () {
              isMouseover = true;
              toggleActive(true);
            });
            circle.on('mouseout', function () {
              isMouseover = false;
              toggleActive(false);
            });

            if (blink) {
              var isActive = false;
              var intervalId = setInterval(function () {
                var obj = _this.getMarkerObjectById(_id5);

                if (obj !== circle) {
                  clearInterval(intervalId);
                } else {
                  toggleActive(isActive);
                  isActive = !isActive;
                }
              }, 1000);
            }

            if (_this.map) {
              circle.setMap(_this.map);
            }

            _this.markerObjectMap.set(_id5, circle);

            break;
          }

        case STMapMarkerType.polygon:
          {
            var _id6 = markerData.id,
                _icon6 = markerData.icon,
                _data4 = markerData.data;
            var _path2 = _icon6.path,
                _fillStyle = _icon6.fillStyle,
                _borderStyle2 = _icon6.borderStyle,
                _fillStyleActive = _icon6.fillStyleActive,
                _blink = _icon6.blink,
                _borderStyleActive = _icon6.borderStyleActive;
            if (!_path2.length) return; // @ts-ignore

            var polygon = new AMap.Polygon({
              path: _path2,
              cursor: _data4.code === FeatureType.noFunc ? 'default' : 'pointer',
              fillColor: _fillStyle.color,
              fillOpacity: _fillStyle.opacity,
              strokeColor: _borderStyle2.color,
              strokeWeight: _borderStyle2.width,
              strokeOpacity: _borderStyle2.opacity,
              zIndex: zIndex,
              extData: {
                markerData: markerData
              }
            });
            polygon.on('click', function () {
              _this.onMarkerClick == null ? void 0 : _this.onMarkerClick(_id6, polygon);
            });
            var _isMouseover = false;

            var _toggleActive = function _toggleActive(isActive) {
              var isOn = _isMouseover || isActive;
              polygon.setOptions({
                fillColor: isOn ? _fillStyleActive.color : _fillStyle.color,
                fillOpacity: isOn ? _fillStyleActive.opacity : _fillStyle.opacity,
                strokeColor: isOn ? _borderStyleActive.color : _borderStyle2.color,
                strokeWeight: isOn ? _borderStyleActive.width : _borderStyle2.width,
                strokeOpacity: isOn ? _borderStyleActive.opacity : _borderStyle2.opacity
              });
            };

            polygon.on('mouseover', function () {
              _isMouseover = true;

              _toggleActive(true);
            });
            polygon.on('mouseout', function () {
              _isMouseover = false;

              _toggleActive(false);
            });

            if (_blink) {
              var _isActive = false;

              var _intervalId = setInterval(function () {
                var obj = _this.getMarkerObjectById(_id6);

                if (obj !== polygon) {
                  clearInterval(_intervalId);
                } else {
                  _toggleActive(_isActive);

                  _isActive = !_isActive;
                }
              }, 1000);
            }

            if (_this.map) {
              polygon.setMap(_this.map);
            }

            _this.markerObjectMap.set(_id6, polygon);

            if (_icon6.animation.type === 1) {
              var _icon6$animation = _icon6.animation,
                  _markerIcon2 = _icon6$animation.markerIcon,
                  _markerWidth2 = _icon6$animation.markerWidth,
                  _markerHeight2 = _icon6$animation.markerHeight,
                  _icon6$animation$mark = _icon6$animation.markerScale,
                  _markerScale2 = _icon6$animation$mark === void 0 ? 1 : _icon6$animation$mark;

              var _width3 = _markerWidth2 * _markerScale2;

              var _height3 = _markerHeight2 * _markerScale2;

              var _animationMarker2 = new AMap.Marker({
                map: _this.getMap(),
                position: _path2[0],
                icon: new AMap.Icon({
                  size: new AMap.Size(_width3, _height3),
                  image: "" + _this.publicDomain + _markerIcon2,
                  imageSize: new AMap.Size(_width3, _height3)
                }),
                anchor: 'center'
              });

              _animationMarker2.moveAlong([].concat(_path2, [_path2[0]]), {
                duration: 500,
                autoRotation: true,
                circlable: true
              });

              _this.animationMarkerMap.set(_id6, _animationMarker2);
            }

            break;
          }
      }
    };

    this.removeMarker = function (id) {
      var _this$layerMap$get;

      var marker = _this.markerObjectMap.get(id);

      if (marker) {
        marker.setMap(null);

        _this.markerObjectMap["delete"](id);
      }

      _this.zoomWatchingMap["delete"](id);

      var animationMarker = _this.animationMarkerMap.get(id);

      if (animationMarker) {
        animationMarker.stopMove();
        animationMarker.setMap(null);

        _this.animationMarkerMap["delete"](id);
      }

      var layer = (_this$layerMap$get = _this.layerMap.get(id)) == null ? void 0 : _this$layerMap$get.layer;

      if (layer) {
        layer.destroy();

        _this.layerMap["delete"](id);
      }
    };

    this.removeMap = function () {
      var _this$loca, _this$map5, _this$map5$getContext, _this$map5$getContext2, _this$map6;

      Array.from(_this.animationMarkerMap.values()).forEach(function (x) {
        x.stopMove();
        x.setMap(null);
      });

      _this.markerObjectMap.clear();

      _this.animationMarkerMap.clear();

      _this.layerMap.clear();

      _this.zoomWatchingMap.clear();

      _this.zIndexMap.clear();

      (_this$loca = _this.loca) == null ? void 0 : _this$loca.destroy();
      _this.loca = undefined;
      (_this$map5 = _this.map // @ts-ignore
      ) == null ? void 0 : (_this$map5$getContext = _this$map5.getContext('webgl')) == null ? void 0 : (_this$map5$getContext2 = _this$map5$getContext.getExtension('WEBGL_lose_context')) == null ? void 0 : _this$map5$getContext2.loseContext();
      (_this$map6 = _this.map) == null ? void 0 : _this$map6.destroy();
      _this.map = undefined;
    };

    this.autoFit = function () {
      var _this$markerObjectMap, _this$map7;

      var list = Array.from((_this$markerObjectMap = _this.markerObjectMap) == null ? void 0 : _this$markerObjectMap.values());
      var layerList = Array.from(_this.layerMap.values()).map(function (x) {
        return new AMap.Polyline({
          path: x.data.icon.path
        });
      });
      (_this$map7 = _this.map) == null ? void 0 : _this$map7.setFitView([].concat(list, layerList), true);
    };

    this.selectMarker = function (id) {
      _this.unselect();

      var marker = _this.markerObjectMap.get(id);

      if (!marker) return;
      _this.selectedId = id;
      var markerData = marker.getExtData().markerData;

      if (markerData.type === undefined || markerData.type === STMapMarkerType.scene) {
        marker.setContent(_this.markerIcon(markerData.icon, {
          isActive: true
        }));
        marker.setzIndex(SELELCTED_ZINDEX);

        if (!_this.hideRadar && markerData.icon.showRadar && markerData.data.sceneType === SceneType.pano) {
          var _this$radar3, _this$radar4;

          (_this$radar3 = _this.radar) == null ? void 0 : _this$radar3.setPosition([markerData.icon.lng, markerData.icon.lat]);
          (_this$radar4 = _this.radar) == null ? void 0 : _this$radar4.setMap(_this.map);
        }
      }
    };

    this.unselect = function () {
      var _this$radar5;

      var id = _this.selectedId;
      if (!id) return;
      (_this$radar5 = _this.radar) == null ? void 0 : _this$radar5.remove();
      _this.selectedId = undefined;

      var marker = _this.markerObjectMap.get(id);

      if (!marker) return;
      var markerData = marker.getExtData().markerData;

      if (markerData.type === undefined || markerData.type === STMapMarkerType.scene) {
        marker.setContent(_this.markerIcon(markerData.icon));
        marker.setzIndex(_this.getZIndex(id));
      }
    };

    this.updateAngle = function (angle) {
      if (!_this.isRotating) {
        var _this$radar6;

        (_this$radar6 = _this.radar) == null ? void 0 : _this$radar6.setAngle(angle);
      }
    };

    this.showSelectedOnly = function () {
      Array.from(_this.markerObjectMap.values()).forEach(function (marker) {
        _this.removeMarker(marker.getExtData().markerData.id);
      });

      _this.markerObjectMap.forEach(function (marker) {
        marker.remove();
      });
    };

    this.showAll = function () {
      Array.from(_this.markerObjectMap.values()).forEach(function (marker) {
        _this.addMarker(marker.getExtData().markerData, {
          hide: false
        });
      });
    };

    this.setMarkerSize = function (size) {
      _this.markerSize = size;

      _this.markerObjectMap.forEach(function (marker) {
        var markerData = marker.getExtData().markerData;
        if (!markerData) return;

        switch (markerData.type) {
          case undefined:
          case STMapMarkerType.scene:
          case STMapMarkerType.point:
            marker.setContent(_this.markerIcon(markerData.icon));
            break;
        }
      });

      if (_this.selectedId) {
        _this.selectMarker(_this.selectedId);
      }
    };

    this.setHideTitle = function (hide) {
      _this.hideTitle = hide;

      _this.markerObjectMap.forEach(function (marker) {
        var markerData = marker.getExtData().markerData;
        if (!markerData) return;

        switch (markerData.type) {
          case undefined:
          case STMapMarkerType.scene:
          case STMapMarkerType.point:
            marker.setLabel(_this.markerLabel(markerData));
            break;
        }
      });

      if (_this.selectedId) {
        _this.selectMarker(_this.selectedId);
      }
    };

    this.changeLayer = function (layerType) {
      if (layerType === 0) {
        _this.layers.forEach(function (layer) {
          var _this$map8;

          (_this$map8 = _this.map) == null ? void 0 : _this$map8.removeLayer(layer);
        });

        _this.layers = [];
      } else if (layerType === 1) {
        var _this$map9;

        var layer = new AMap.TileLayer.Satellite();
        (_this$map9 = _this.map) == null ? void 0 : _this$map9.addLayer(layer);

        _this.layers.push(layer);
      }
    };

    this.setRadarSize = function (size) {
      var _this$radar7;

      _this.radarSize = size;
      (_this$radar7 = _this.radar) == null ? void 0 : _this$radar7.setContent(_this.generateRadarIcon());
    };

    this.setCenter = function (location) {
      var _this$map$getCenter$l, _this$map10, _this$map$getCenter$l2, _this$map11, _this$map$getZoom3, _this$map12, _this$map13;

      var curLocation = {
        lng: (_this$map$getCenter$l = (_this$map10 = _this.map) == null ? void 0 : _this$map10.getCenter().lng) != null ? _this$map$getCenter$l : 0,
        lat: (_this$map$getCenter$l2 = (_this$map11 = _this.map) == null ? void 0 : _this$map11.getCenter().lat) != null ? _this$map$getCenter$l2 : 0,
        zoom: (_this$map$getZoom3 = (_this$map12 = _this.map) == null ? void 0 : _this$map12.getZoom()) != null ? _this$map$getZoom3 : 13
      };

      var _curLocation = _extends({}, curLocation, typeof location === 'function' ? location(curLocation) : location),
          lat = _curLocation.lat,
          lng = _curLocation.lng,
          zoom = _curLocation.zoom;

      (_this$map13 = _this.map) == null ? void 0 : _this$map13.setZoomAndCenter(zoom, [lng, lat], true);
    };

    this.setMapStyle = function (mapStyle) {
      var _this$map14;

      if (mapStyle === void 0) {
        mapStyle = 'normal';
      }

      (_this$map14 = _this.map) == null ? void 0 : _this$map14.setMapStyle("amap://styles/" + mapStyle);
    };

    this.getMarkerObjectById = function (id) {
      var markerObject = _this.markerObjectMap.get(id);

      if (!markerObject) return null;
      return markerObject;
    };

    this.clearAll = function () {
      Array.from(_this.animationMarkerMap.values()).forEach(function (x) {
        x.stopMove();
        x.setMap(null);
      });
      Array.from(_this.layerMap.values()).forEach(function (x) {
        _this.removeMarker(x.data.id);
      });

      _this.getMap().clearMap();

      _this.markerObjectMap.clear();

      _this.animationMarkerMap.clear();

      _this.layerMap.clear();

      _this.zoomWatchingMap.clear();

      _this.zIndexMap.clear();
    };
  }

  var _proto = AMapSandTable.prototype;

  _proto.getZoomScale = function getZoomScale(_ref2) {
    var zoom = _ref2.zoom,
        _ref2$baseZoom = _ref2.baseZoom,
        baseZoom = _ref2$baseZoom === void 0 ? 13 : _ref2$baseZoom;
    var defaultZoom = baseZoom;
    var defaultSize = 1;
    var diff = zoom - defaultZoom; // 根据差值计算大小百分比
    // 使用**运算符来计算放大或缩小的倍数
    // 例如，diff为1时，表示放大1倍，即2 ** 1 = 2
    // diff为-1时，表示缩小一倍，即2 ** -1 = 0.5

    return defaultSize * Math.pow(2, diff);
  };

  _proto.init = function init(_ref3) {
    var _data$initialView,
        _this2 = this,
        _data$initialView2,
        _this$map15;

    var target = _ref3.target,
        data = _ref3.data,
        selectedId = _ref3.selectedId,
        _ref3$showSelectedOnl = _ref3.showSelectedOnly,
        showSelectedOnly = _ref3$showSelectedOnl === void 0 ? false : _ref3$showSelectedOnl,
        markerSize = _ref3.markerSize,
        _ref3$hideTitle = _ref3.hideTitle,
        hideTitle = _ref3$hideTitle === void 0 ? false : _ref3$hideTitle,
        _ref3$radarSize = _ref3.radarSize,
        radarSize = _ref3$radarSize === void 0 ? 114 : _ref3$radarSize,
        _ref3$hideRadar = _ref3.hideRadar,
        hideRadar = _ref3$hideRadar === void 0 ? false : _ref3$hideRadar,
        publicDomain = _ref3.publicDomain,
        mediaDomain = _ref3.mediaDomain,
        onMarkerClick = _ref3.onMarkerClick,
        onRadarRotate = _ref3.onRadarRotate,
        onReady = _ref3.onReady,
        onMapClick = _ref3.onMapClick;
    this.markerSize = markerSize;
    this.hideTitle = hideTitle;
    this.hideRadar = hideRadar;
    this.publicDomain = publicDomain;
    this.mediaDomain = mediaDomain;
    this.radarSize = radarSize;

    if (this.map) {
      Array.from(this.animationMarkerMap.values()).forEach(function (x) {
        x.stopMove();
        x.setMap(null);
      });
      this.map.clearMap();
    } else {
      var _this$loca2;

      this.map = new AMap.Map(target, {});
      (_this$loca2 = this.loca) == null ? void 0 : _this$loca2.destroy();
      this.loca = new Loca.Container({
        map: this.map
      });
      this.loca.animate.start();
    }

    this.markerObjectMap = new Map();
    this.zoomWatchingMap = new Map();
    this.animationMarkerMap = new Map();
    this.layerMap = new Map();
    this.zIndexMap = new Map();
    this.changeLayer(data.layerType);
    this.setMapStyle(data.layerStyle);

    if (((_data$initialView = data.initialView) == null ? void 0 : _data$initialView.type) === 1) {
      this.map.setZoomAndCenter(data.initialView.zoom, [data.initialView.lng, data.initialView.lat], true);
    }

    if (onMapClick) {
      this.map.on('click', onMapClick);
    }

    this.onMarkerClick = onMarkerClick;
    this.onRadarRotate = onRadarRotate;

    if (showSelectedOnly) {
      var marker = data.markers.find(function (x) {
        return x.id === selectedId;
      });

      if (marker) {
        this.addMarker(marker);
      }
    } else {
      data.markers.forEach(function (marker) {
        _this2.addMarker(marker);
      });
    }

    if (((_data$initialView2 = data.initialView) == null ? void 0 : _data$initialView2.type) === 0) {
      this.autoFit();
    }

    this.radar = new AMap.Marker({
      content: this.generateRadarIcon(),
      cursor: 'ew-resize',
      anchor: 'center',
      zIndex: SELELCTED_ZINDEX - 1
    });
    this.radar.on('mousedown', function () {
      var _this2$map;

      _this2.isRotating = true;
      (_this2$map = _this2.map) == null ? void 0 : _this2$map.setStatus({
        dragEnable: false
      });
      document.addEventListener('mouseup', _this2.onMouseUp); // @ts-ignore

      document.addEventListener('mousemove', _this2.onMouseMove);
    });
    this.radar.on('touchstart', function () {
      var _this2$map2;

      _this2.isRotating = true;
      (_this2$map2 = _this2.map) == null ? void 0 : _this2$map2.setStatus({
        dragEnable: false
      });
      document.addEventListener('touchend', _this2.onMouseUp); // @ts-ignore

      document.addEventListener('touchmove', _this2.onMouseMove);
    });
    (_this$map15 = this.map) == null ? void 0 : _this$map15.on('zoomchange', function () {
      var items = Array.from(_this2.zoomWatchingMap.values());
      items.forEach(function (item) {
        var itemData = _this2.getExtData(item).markerData;

        if (itemData.type === STMapMarkerType.image) {
          _this2.imageContent(itemData.icon).then(function (iconObj) {
            item.setIcon(iconObj);
          });
        } else if (itemData.type === STMapMarkerType.text) {
          if (itemData.icon.stick) {
            item.setStyle(_this2.textStyle(itemData));
          }
        }
      });
    });

    if (selectedId) {
      this.selectMarker(selectedId);
    }

    onReady == null ? void 0 : onReady(this.map);
  };

  return AMapSandTable;
}();

export { AMapSandTable };
//# sourceMappingURL=pano-amap.esm.js.map
